/* tslint:disable:max-line-length */
import { SegmentSpecificMessages } from "../../types/types";

export const lowIncomeMessages: SegmentSpecificMessages = {
  emailExplanation: "",
  addressExplanation: "Use your home address",
  step: {
    personalInfo: {
      title: "Unlock this Special Offer",
      subtitle: "Verify you qualify for an eligible government assistance program.",
      howDoesVerifyingWorkDetails:
        "To be eligible for this offer, you must currently qualify for an eligible government assistance program. The eligible Government Assistance Programs for this offer can be found in the box below." +
        "<br><br>" +
        "{companyName} uses SheerID, a trusted partner, to verify that you are a recipient of these benefits. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
      tryAgain: {
        title: "Check Your full name & other fields",
        subtitle: "Your information must match what is on your government-issued document(s).",
      },
      verifyingTitle: "Verifying your status",
    },
    docUpload: {
      title: "We need some more info",
      subtitle:
        "Documents will be reviewed in {estimatedWaitTime} by staff at SheerID, a trusted partner.",
      howDoesVerifyingWorkDetails:
        "Document review is handled by SheerID, a trusted partner who specializes in verifying your eligibility." +
        "<br><br>" +
        "Documents are used only for verifying your eligibility status is current and will be permanently deleted after review is finalized.",
      uploadInstructions: "Upload an official document that shows",
    },
    success: {
      title: "You've been verified",
      subtitle: "Here is your personal coupon code. It is unique to you and can only be used once.",
      redirectButtonText: "Use code now",
    },
  },
};
